import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { checkToken } from "../utils/Auth";
import Alert from "../utils/Alert";
import { useStudentContext } from "../context/StudentContext";

const Header = () => {
  useEffect(() => {
    if (window.jQuery) {
      window.jQuery(document).ready(() => {
        window.jQuery("#search_input_box").hide();
        window.jQuery("#search").on("click", () => {
          window.jQuery("#search_input_box").slideToggle("slow");
          window.jQuery("#search_input").focus();
        });
        window.jQuery("#close_search").on("click", () => {
          window.jQuery("#search_input_box").slideUp("slow");
        });
      });
    }
  }, []);

  const [isFixed, setIsFixed] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const navOffsetTop = document.querySelector("header").offsetHeight + 50;
      if (window.scrollY >= navOffsetTop) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const token = checkToken();

  const { studentData } = useStudentContext();

  const navLinks = [
    { path: "/", name: "Home" },
    { path: "/about", name: "About" },
    { path: "/course", name: "Course" },
    { path: "/erp", name: "ERP" },
    { path: "/contact", name: "Contact" },
  ];
  if (!token) {
    navLinks.push({ path: "/login", name: "Login" });
    navLinks.push({ path: "/register", name: "Register" });
  }

  const handelLogout = () => {
    localStorage.removeItem("token");
    Alert.success("Logout Success!");
    navigate("/");
  };

  return (
    <header
      style={{ background: "#fff" }}
      className={`header_area ${isFixed ? "navbar_fixed" : ""}`}
    >
      <div className="main_menu">
        <div className="search_input" id="search_input_box">
          <div className="container">
            <form
              className="d-flex justify-content-between"
              method=""
              action=""
            >
              <input
                type="text"
                className="form-control"
                id="search_input"
                placeholder="Search Here"
              />
              <button type="submit" className="btn"></button>
              <span
                className="ti-close"
                id="close_search"
                title="Close Search"
              ></span>
            </form>
          </div>
        </div>

        <nav className="navbar navbar-expand-lg navbar-light">
          <div className="container">
            <Link
              className="navbar-brand logo_h"
              to="/"
            >
             <img src="/assets/img/logo.png" alt="" />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-bar"></span>{" "}
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <div
              className="collapse navbar-collapse offset"
              id="navbarSupportedContent"
            >
              <ul className="nav navbar-nav menu_nav ml-auto">
                {navLinks.map((item) => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) =>
                      isActive ? "nav-item active" : "nav-item"
                    }
                  >
                    <li>
                      <span className="nav-link">{item.name}</span>
                    </li>
                  </NavLink>
                ))}
                {token && studentData && (
                  <>
                    <li className="nav-item submenu dropdown">
                      <button
                        type="button"
                        className="nav-link dropdown-toggle"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        style={{ background: "transparent", border: 0 }}
                      >
                        {studentData.name}
                      </button>
                      <ul className="dropdown-menu">
                        <li className="nav-item">
                          <Link className="nav-link" to={"/profile"}>
                            Profile
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to={"/changePassword"}>
                            Change Password
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to={"/booking"}>
                            Course History
                          </Link>
                        </li>
                        <li className="nav-item">
                          <button
                            type="button"
                            className="nav-link text-danger"
                            onClick={handelLogout}
                          >
                            Logout
                          </button>
                        </li>
                      </ul>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
